import { getNavigator } from '@jira/ssr__browser-globals/src/getNavigator.tsx';
import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */
const isJsDomEnvironment = () =>
	getWindow()?.name === 'nodejs' ||
	getNavigator()?.userAgent.includes('Node.js') ||
	getNavigator()?.userAgent.includes('jsdom');

export const isServerEnvironment = (): boolean => {
	if (
		getWindow() === undefined ||
		(typeof process !== 'undefined' && process.versions != null && process.versions.node != null)
	) {
		return true;
	}

	if (isJsDomEnvironment()) {
		return true;
	}

	return false;
};
